export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";